module.exports = __webpack_public_path__ + "img/MX.216d2ed6.svg";